export default __webpack_public_path__ + "static/media/Grouport.abb76ab7.jpg";